import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/init-base-styles/init-base-styles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsWrapper"] */ "/app/app/lib/analytics/AnalyticsWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApolloWrapper"] */ "/app/app/lib/apollo-client/ApolloWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/lib/datadog/rum-init.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nerdwallet/base-styles/base.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nerdwallet/base-styles/reset.css");
;
import(/* webpackMode: "eager" */ "/app/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/app/styles/main.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
